import { render, staticRenderFns } from "./CollectionsHome.vue?vue&type=template&id=7fcee305&scoped=true&"
import script from "./CollectionsHome.vue?vue&type=script&lang=js&"
export * from "./CollectionsHome.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsHome.vue?vue&type=style&index=0&id=7fcee305&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcee305",
  null
  
)

export default component.exports